import { DotsThreeVerticalIcon } from "@phosphor-icons/react/dist/csr/DotsThreeVertical";
import { Button } from "@volca/ui/components/ui/button";
import {
  DropdownMenuItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenu,
} from "@volca/ui/components/ui/dropdown-menu";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { useGetAchAccount } from "@/internal-transactions/query";

interface PaymentsActionsProps {
  businessId?: string | null;
  onDeposit: () => void;
  onWithdraw: () => void;
  onAutoRefillBalance: () => void;
  onEditBankDetails: () => void;
}

export const PaymentsActions = ({
  businessId,
  onDeposit,
  onWithdraw,
  onAutoRefillBalance,
  onEditBankDetails,
}: PaymentsActionsProps) => {
  const { data: achAccount, isLoading } = useGetAchAccount(businessId);

  const hasAchAccount = !!achAccount;

  if (isLoading) {
    return (
      <Stack
        gap={4}
        direction="row"
        align="center"
        className="flex-wrap gap-y-2"
      >
        <Skeleton className="h-8 w-39 rounded-lg" />
        <Skeleton className="h-8 w-44 rounded-lg" />
        <Skeleton className="size-8 rounded-lg" />
      </Stack>
    );
  }

  if (!hasAchAccount) return null;

  return (
    <Stack gap={4} direction="row" align="center">
      <Button onClick={onDeposit}>Deposit funds</Button>
      <Button onClick={onWithdraw} variant="secondary">
        Withdraw funds
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button
              variant="ghost"
              size="icon"
              aria-label="More payment actions"
            />
          }
        >
          <DotsThreeVerticalIcon className="h-6 w-6" />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="min-w-max">
          <DropdownMenuItem onClick={onAutoRefillBalance}>
            Auto-refill balance
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onEditBankDetails}>
            Edit payment settings
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </Stack>
  );
};
